import { toDisplayString as _toDisplayString, resolveComponent as _resolveComponent, createVNode as _createVNode, createTextVNode as _createTextVNode, createElementVNode as _createElementVNode, vModelText as _vModelText, withDirectives as _withDirectives, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "content-container" }
const _hoisted_2 = { class: "title" }
const _hoisted_3 = { class: "margin-top-8px" }
const _hoisted_4 = { class: "input-container" }
const _hoisted_5 = { class: "input-container" }
const _hoisted_6 = { class: "input-container" }
const _hoisted_7 = { class: "input-container" }
const _hoisted_8 = { class: "input-container" }
const _hoisted_9 = { class: "input-container" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_ReglePastille = _resolveComponent("ReglePastille")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createTextVNode(_toDisplayString(_ctx.$t('outils.compteur.step.one.title.partenaire')) + " ", 1),
      _createVNode(_component_ReglePastille, { cle: "outils.etape1Obligatoire" })
    ]),
    _createElementVNode("div", _hoisted_3, _toDisplayString(_ctx.$t('outils.compteur.step.one.two.subtitle.check')), 1),
    _createElementVNode("div", _hoisted_4, [
      _createElementVNode("div", null, _toDisplayString(_ctx.$t('outils.compteur.step.one.raison.sociale')), 1),
      _withDirectives(_createElementVNode("input", {
        class: "text-input",
        "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.raisonSociale) = $event))
      }, null, 512), [
        [_vModelText, _ctx.raisonSociale]
      ])
    ]),
    _createElementVNode("div", _hoisted_5, [
      _createElementVNode("div", null, _toDisplayString(_ctx.$t('outils.compteur.step.one.nom.commercial')), 1),
      _withDirectives(_createElementVNode("input", {
        class: "text-input",
        "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.nomCommercial) = $event))
      }, null, 512), [
        [_vModelText, _ctx.nomCommercial]
      ])
    ]),
    _createElementVNode("div", _hoisted_6, [
      _createElementVNode("div", null, _toDisplayString(_ctx.$t('outils.compteur.step.one.numero.identification')), 1),
      _withDirectives(_createElementVNode("input", {
        class: "text-input",
        "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.numeroIdentification) = $event))
      }, null, 512), [
        [_vModelText, _ctx.numeroIdentification]
      ])
    ]),
    _createElementVNode("div", _hoisted_7, [
      _createElementVNode("div", null, _toDisplayString(_ctx.$t('outils.compteur.step.one.adresse.postale')), 1),
      _withDirectives(_createElementVNode("input", {
        class: "text-input",
        "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.adressePostale) = $event))
      }, null, 512), [
        [_vModelText, _ctx.adressePostale]
      ])
    ]),
    _createElementVNode("div", _hoisted_8, [
      _createElementVNode("div", null, _toDisplayString(_ctx.$t('outils.compteur.step.one.code.postal')), 1),
      _withDirectives(_createElementVNode("input", {
        class: "text-input",
        "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.codePostal) = $event)),
        type: "number",
        onKeypress: _cache[5] || (_cache[5] = ($event: any) => (_ctx.disableNegatif($event))),
        min: "0"
      }, null, 544), [
        [_vModelText, _ctx.codePostal]
      ])
    ]),
    _createElementVNode("div", _hoisted_9, [
      _createElementVNode("div", null, _toDisplayString(_ctx.$t('outils.compteur.step.one.ville')), 1),
      _withDirectives(_createElementVNode("input", {
        class: "text-input",
        "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((_ctx.ville) = $event))
      }, null, 512), [
        [_vModelText, _ctx.ville]
      ])
    ])
  ]))
}